
<!--
* A progress bar component
*
* @param {number} currentStep - The current step
* @param {number} totalSteps - The total number of steps
-->

<template>
  <div class="progress_bar">
    <div class="progress_bar__current_step"
         v-bind:style="calculateCurrentStepWidth">
    </div>
    <div class="progress_bar__remainder_steps"></div>
  </div>
</template>

<script>
  export default {
    props: {
      currentStep: {
        required: true,
        type: Number
      },
      totalSteps: {
        validator: function (value) {
          return value > 0
        },
        required: true,
        type: Number
      }
    },
    computed: {
      /**
       * Calculates percentage of total steps, current steps is
       *
       * @returns {string} the percentage of total steps
       */
      calculateCurrentStepWidth () {
        let computedCurrentStep = this.currentStep

        // Fallback to 0 if current step is greater than total steps
        if (this.currentStep > this.totalSteps) {
          computedCurrentStep = 0
        }
        return 'width: ' + (computedCurrentStep / this.totalSteps) * 100 + '%'
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "../assets/sass/shared.scss";

  .progress_bar {
    height: $dims-progress-bar-height;
    display: flex;
  }

  .progress_bar__current_step {
    transition: width $default-transition-duration * 2 $default-easing;
    background-color: $progress-bar-brand-color;
  }

  .progress_bar__remainder_steps {
    background-color: $tertiary-brand-color;
    flex: 1;
  }
</style>
